<template>
  <el-select
    :value="value"
    filterable
    clearable
    :loading="loading"
    style="width: 100%"
    @change="onChange"
  >
    <el-option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :label="option.label"
    />
  </el-select>
</template>

<script>
  import { countriesApi } from '@/api';

  let countriesRequest = null;

  function loadCountries() {
    if (!countriesRequest) {
      countriesRequest = countriesApi
        .index()
        .then(({ data }) => data)
        .catch((error) => {
          countriesRequest = null;
          throw error;
        });
    }
    return countriesRequest;
  }

  export default {
    name: 'CountryCodeSelect',
    props: {
      value: { type: String, default: null },
    },
    data() {
      return {
        countries: [],
        loading: false,
      };
    },
    computed: {
      options() {
        const options = this.countries.map(({ code, name }) => ({
          value: code,
          label: name ? `${name} (${code})` : code,
        }));
        if (this.value && !options.some((o) => o.value === this.value)) {
          options.unshift({ value: this.value, label: this.value });
        }
        return options;
      },
    },
    async created() {
      this.loading = true;
      try {
        this.countries = await loadCountries();
      } catch (error) {
        this.$notify({
          showClose: true,
          type: 'error',
          message: error?.response?.data?.error?.message ?? error.message,
        });
      } finally {
        this.loading = false;
      }
    },
    methods: {
      onChange(code) {
        const value = code || null;
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
  };
</script>
